import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ContribLegge5992WarningsService } from './warnings/contrib-legge-59-92.warnings';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [ContribLegge5992WarningsService],
})
export class ContribLegge5992FormModule {}
